import React from 'react';
import BaseComponent from 'apps/new-web/views/component';
import Icon from 'apps/new-web/views/components/icon';
import IconToggle from 'apps/new-web/views/components/icon-toggle';
import benefits from './benefit-list';
import { blueGray54 } from 'apps/new-web/views/themes/colors';

export default class BenefitsListMobile extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = { toggleStartingY: 530 };
  }

  componentDidMount() {
    this.setToggleOffset();
    window.addEventListener('resize', this.setToggleOffset);
  }

  componentWillUnMount() {
    window.removeEventListener('resize', this.setToggleOffset);
  }

  setToggleOffset() {
    this.setState({ toggleStartingY: window.innerWidth > 360 ? 530 : 600 });
  }

  renderExpanded() {
    return (
      <div className="benefits">
        { benefits.map( (benefit, idx) => (
          idx <= 1
            ? null
            : <div className="item" key={ `benefit-${benefit.icon.name}` }>
              <span className="icon">
                <Icon icon={ benefit.icon } color={ blueGray54 } size={ 20 } />
              </span>
              <h3>{ benefit.title }</h3>
              <p>{ benefit.content }</p>
            </div>
        ))
        }
      </div>
    );
  }
  render() {
    return (
      <div className="benefits">
        <IconToggle
          topOffset={ -600 }
          bottomOffset={ 0 }
          startingY={ this.state.toggleStartingY }
          navDown={ false }
          expandedSection={ this.renderExpanded() }
          iconAnchor=".benefits"
        >
          { benefits.map( (benefit, idx) => (
            idx > 1
              ? null
              : <div className="item" key={ `benefit-${benefit.icon.name}` }>
                <span className="icon">
                  <Icon icon={ benefit.icon } color={ blueGray54 } size={ 20 } />
                </span>
                <h3>{ benefit.title }</h3>
                <p>{ benefit.content }</p>
              </div>
          ))
          }
        </IconToggle>
      </div>
    );
  }
}
